import { BeiAn } from "@quark/design";
import styles from "./index.module.scss";

const Footer = () => {
  return (
    <div className={styles.footer}>
      <BeiAn className={styles.beian} />
    </div>
  );
};

export default Footer;
